module.exports = __webpack_public_path__ + "img/onlineExpo_favorite.ef4d2078.png";